<template>
  <div>
    <el-form size="small">
      <el-row :gutter="15">
        <el-col :span="12">
          <DateForm ref="dateForm" />
        </el-col>
      </el-row>
      <el-row :gutter="15">
        <el-col :span="12">
          <el-form-item label="Customer">
            <AccountAutoComplete
              ref="accountAutoComplete"
              v-model="account"
              @loadCarrier="loadCarrier"
            />
            <el-checkbox
              v-model="form.showChildrenAccts"
              label="Include Child Accounts"
            />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="Carrier">
            <CarrierAutoComplete
              ref="carrierList"
              v-model="carrier"
            />
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="15">
        <el-col :span="12">
          <el-form-item label="Portfolio">
            <PortfolioAutoComplete
              ref="portfolioList"
              v-model="portfolio"
            />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="Billing Group">
            <BusinessGroupAutoComplete
              ref="billingGroupList"
              v-model="billingGroup"
            />
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="15">
        <el-col :span="12">
          <el-form-item
            label="Breakdown By"
          >
            <el-select
              v-model="breakdown"
              class="w-100"
              placeholder="Breakdown By"
            >
              <el-option
                v-for="item in breakdownOption"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              />
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="Account Type">
            <AccountTypeAutoComplete
              ref="acctypeList"
              v-model="accountType"
            />
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="15">
        <el-col :span="8">
          <el-form-item>
            <el-checkbox
              v-model="form.showBilledOnly"
              label="Show Billed Only"
            />
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item>
            <el-checkbox
              v-model="form.showMarginData"
              label="Show Margins Data"
            />
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item>
            <el-checkbox
              v-model="form.internalConsOnly"
              label="Exclude Third Party & Ignored"
            />
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <el-row>
      <el-col>
        <el-button
          type="primary"
          size="small"
          class="float-right"
          @click.native="downloadCSV()"
        >
          Generate Report
        </el-button>
      </el-col>
    </el-row>
    <Preview
      v-if="isShowPreview"
      title="Freight Summary Report"
      :is-show.sync="isShowPreview"
      :configuration="configuration"
    />
  </div>
</template>

<script>

import DateForm from '@/components/Application/Reports/DateForm'
import CarrierAutoComplete from '@/components/Application/Reports/CarrierAutoComplete'
import PortfolioAutoComplete from '@/components/Application/Reports/PortfolioAutoComplete'
import BusinessGroupAutoComplete from '@/components/Application/Reports/BusinessGroupAutoComplete'
import AccountTypeAutoComplete from '@/components/Application/Reports/AccountTypeAutoComplete'
import AccountAutoComplete from '@/components/Application/Reports/AccountAutoComplete'
import Preview from '@/components/Application/Reports/Preview'

export default {
  components: {
    DateForm,
    AccountAutoComplete,
    CarrierAutoComplete,
    PortfolioAutoComplete,
    BusinessGroupAutoComplete,
    AccountTypeAutoComplete,
    Preview
  },
  data () {
    return {
      pageTitle: 'Summary',
      breadcrumb: {
        name: 'Summary',
        route: { name: 'reports-freigt-summary' }
      },
      account: {},
      carrier: {},
      portfolio: {},
      billingGroup: {},
      accountType: {},
      form: {
        dateFrom: null,
        dateTo: null,
        accountId: null,
        showChildrenAccts: false,
        showBilledOnly: false,
        internalConsOnly: true, // Exclude Third Party & Ignored
        carrierId: '',
        showDifotData: false,
        showMarginData: false,
        portfolioId: '',
        acctypeId: '',
        bgroupId: '',
        carrierBreakDown: false,
        zone: false,
        carrierService: false,
        state: false,
        accountBreakdown: true
      },
      breakdown: null,
      breakdownOption: [
        {
          label: 'Account',
          value: 'accountBreakdown'
        },
        {
          label: 'Carrier',
          value: 'carrierBreakDown'
        },
        {
          label: 'Zone',
          value: 'zone'
        },
        {
          label: 'Carrier Service',
          value: 'carrierService'
        },
        {
          label: 'State',
          value: 'state'
        }
      ],
      isShowPreview: false,
      configuration: null
    }
  },
  watch: {
    breakdown: function (varriable, preVal) {
      this.form[varriable] = true
      if (preVal) {
        this.form[preVal] = false
      }
    }
  },
  methods: {
    setDate (date) {
      this.form.dateFrom = this.$moment(date[0]).format('YYYY-MM-DD HH:mm:ss')
      this.form.dateTo = this.$moment(date[1]).format('YYYY-MM-DD HH:mm:ss')
    },
    loadCarrier () {
      this.form.accountId = this.$refs.accountAutoComplete.getAccountIds()
    },
    downloadCSV () {
      this.$refs.dateForm.$refs.form.validate(async valid => {
        if (valid) {
          this.setDate(this.$refs.dateForm.form.value)
          this.form.carrierId = this.$refs.carrierList.getCarrierId()
          this.form.portfolioId = this.$refs.portfolioList.getPortfolioId()
          this.form.bgroupId = this.$refs.billingGroupList.getBGID()
          this.form.acctypeId = this.$refs.acctypeList.getAcctypeList()

          this.configuration = {
            report: 'FreightSummaryBranch',
            params: this.form
          }
          this.isShowPreview = true
        }
      })
    }

  }
}
</script>

<style>

</style>
